import { twMerge } from "tailwind-merge";

import { Theme } from "../Thumbnail/Thumbnail.theme";
import { GalleryItemModel } from './Gallery.model'

type GalleryBigThumbnailProps = {
    items: GalleryItemModel[]
    handleOnClick: (selectedIndex: number) => void
}

const GalleryBigThumbnail = ({ items, handleOnClick }: GalleryBigThumbnailProps) => {
    if(!items) return null

    return (
        <div className={twMerge(Theme.container)}>
            {items?.map((_, index) => (
                <button
                    key={_?.id}
                    className={twMerge(Theme.image)}
                    onClick={()=> handleOnClick(index)}
                >
                    <img src={_?.thumbnail} alt={_.title} className={twMerge(Theme.image)}/>
                </button>
            ))}
        </div>
    )
}

export default GalleryBigThumbnail